import { Module } from 'wrapper6'
import { scrollToAnchor } from '../utils/_scroll'

const $ = jQuery

export default class SmoothScroll extends Module {
  ready () {
    this.searchScroll()
    this.smoothScroll()
  }

  searchScroll () {
    const ITEMS = document.querySelectorAll('.site-search-tags__post-types a')
    if (ITEMS.length > 0) {
      for (let i = 0; i < ITEMS.length; i++) {
        ITEMS[i].addEventListener('click', (e) => {
          e.preventDefault()
          const URL = ITEMS[i].getAttribute('href')
          URL && scrollToAnchor(URL)
        })
      }
    }
  }

  smoothScroll () {
    const ITEMS = document.querySelectorAll('a[href^="#ss-"]')
    if (ITEMS.length > 0) {
      for (let i = 0; i < ITEMS.length; i++) {
        ITEMS[i].addEventListener('click', (e) => {
          e.preventDefault()
          const URL = ITEMS[i].getAttribute('href')
          URL && scrollToAnchor(URL)
        })
      }
    }
  }
}
